import { type Locale, resolveLocale } from "@/shared/lib/i18n"
import type { User } from "./types"

export function resolveSelectedSearchLocales(
	user: Pick<User, "search_languages" | "app_language">,
): Locale[] {
	const fromServer = user.search_languages
		.map((value) => resolveLocale(value))
		.filter((locale, index, array) => array.indexOf(locale) === index)
	if (fromServer.length > 0) return fromServer
	return [resolveLocale(user.app_language)]
}
